export const TOGAKI_MAX_COUNT = 23; // ト書き1行分の文字数
export const FIRST_SERIFU_MAX_COUNT = 29; // セリフ1行目の文字数
export const SERIFU_MAX_COUNT = 25; // セリフ2行目以降の1行分の文字数
export const HASHIRA_MAX_COUNT = 28; // 柱1行分の文字数
export const MAX_LINES_PER_PAGE = 34; // 1ページあたりの行数
export const STRY_FILE_VERSION = '1'; // STRYファイルのフォーマットバージョン
// IME変換中の文字divに適用するtop。値は変化しないためcomputedではなく定数として保持し、
// BasicSentence.vueのcompositionStartHandlerと、Hashira.vueのcompositionUpdateHandler等で参照する
export const COMPOSING_TOP = '0'; // IME変換中のdivのtop位置
